import { ThunkDispatch, AnyAction } from '@reduxjs/toolkit';

import { CredentialsDto, logout, setCredentials } from '../index';
import { AuthService } from '@shared/lib/services';

type DispatchType = ThunkDispatch<unknown, unknown, AnyAction>;

export async function handleQueryAuthCredentials(
  dispatch: DispatchType,
  queryFulfilled: Promise<{ data: string; meta?: object }>
) {
  try {
    const credentials = (await queryFulfilled).data as unknown as CredentialsDto;

    AuthService.setCredentialsToLocalStorage(credentials);

    dispatch(
      setCredentials({
        userId: credentials.userId,
        accessToken: credentials.accessToken,
        refreshToken: credentials.refreshToken,
      })
    );
  } catch (error) {
    AuthService.clearStorage();
    dispatch(logout());
  }
}
